import React, {useCallback} from 'react';

import {IconButton, Table, Text, TrashBinIcon} from '@phonectas/unifon-ui-kit';
import {truncate} from 'lodash';

interface EmailTableRowProps {
	index: number;
	item: string;
	onDelete: (index: number) => void;
}

const EmailTableRow: React.FC<EmailTableRowProps> = ({index, item, onDelete}) => {
	const handleDelete = useCallback(() => {
		onDelete(index);
	}, [onDelete, index]);

	return (
		<Table.Row
			index={index}
			key={index}
		>
			<Table.Cell>{truncate(item, {length: 38})}</Table.Cell>
			<Table.Cell>
				<Text>
					<IconButton
						color="error"
						onClick={handleDelete}
					>
						<TrashBinIcon />
					</IconButton>
				</Text>
			</Table.Cell>
		</Table.Row>
	);
}

export default EmailTableRow;
